module.exports = __webpack_public_path__ + "media/logon.b79e5e2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/logon.mp4
// module id = 8MVc
// module chunks = 3